import React from "react"

import {
	Stack,
	Typography,
} from "@mui/material"

import Icon from "@mdi/react"

import { AssetCharacteristics } from "models"

export class AttractorItem
{
	constructor(
		public title: string,
		public icon: string,
		public attractor: string,
	)
	{
	}
}

interface DashboardMapAttractorItemProps
{
	item: AttractorItem
	characteristics: AssetCharacteristics
}
interface DashboardMapAttractorItemState
{
}
export class DashboardMapAttractorItem extends React.Component<DashboardMapAttractorItemProps, DashboardMapAttractorItemState>
{
	static defaultProps = {}

	constructor(props: DashboardMapAttractorItemProps)
	{
		super(props)
		this.state = {}
	}

	private getDistanceFromAttractor = (): string => {
		const gMapsAnalysis = this.props.characteristics.gmapsAnalysis

		const distance: number | null = gMapsAnalysis?.[this.props.item.attractor]?.nearest_distance_meters
		if(distance === undefined || distance === null) {
			return "-"
		}
		if(distance >= 1000) {
			return (distance / 1000).toFixed(2) + " Km"
		}

		return distance + " m"
	}

	render()
	{
		return (
			<Stack direction="row" display="flex" alignItems="center" sx={{ width: "100%", }} spacing={2}>
				<Icon path={this.props.item.icon} size={0.8} />
				<Typography flexGrow={1} fontSize="inherit">{this.props.item.title}</Typography>
				<Typography fontSize="inherit">{this.getDistanceFromAttractor()}</Typography>
			</Stack>
		)
	}
}
